export enum UserProperties {
  BROWSER = 'Browser',
  DEVICE = 'Device',
  OS = 'OS',
  REALM = 'Realm'
}
